/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import type ArticleContent from 'embercom/models/articles/article-content';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { ScheduledContentUpdateStatus } from 'embercom/services/scheduled-content-update-service';
import ScheduledContentUpdate from 'embercom/models/content-service/scheduled-content-update';

export interface Args {
  activeContent: ArticleContent;
  showSidePanel: boolean;
  cancelEditActiveContent: () => void;
  saveActiveContent: () => void;
  publishActiveContent: () => Promise<void>;
  toggleSidePanel: () => void;
  scheduleActiveContentUpdate: (params: { scheduledDate: Date }) => Promise<void>;
}

interface Signature {
  Args: Args;
}

export default class Header extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare appService: $TSFixMe;

  get canUseScheduledPublishing() {
    return this.appService.app.canUseScheduledPublishing;
  }

  get scheduledContentUpdates() {
    return (this.args.activeContent.scheduledContentUpdates?.toArray() || []).filter(
      (update: ScheduledContentUpdate) => update.status === ScheduledContentUpdateStatus.PENDING,
    );
  }

  get hasScheduledContentUpdates() {
    return this.scheduledContentUpdates.length > 0;
  }

  get scheduleDisplayText() {
    if (!this.hasScheduledContentUpdates) {
      return null;
    }

    return ScheduledContentUpdate.getScheduleDisplayText(
      this.scheduledContentUpdates[0],
      this.appService.app.timezone,
      this.intl,
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::ArticleContent::Edit::Header': typeof Header;
    'knowledge-hub/content-editor/article-content/edit/header': typeof Header;
  }
}
